export const DATABASE_NAME = 'dev_cache';
export const DATABASE_VERSION = 2;
